import { render, staticRenderFns } from "./tabOne.vue?vue&type=template&id=4e748c5c"
import script from "./tabOne.vue?vue&type=script&lang=js"
export * from "./tabOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports